"use client";

import { SpeedInsights } from '@vercel/speed-insights/next';

export default function VercelSpeedInsights() {
  // These scripts are served by the Vercel edge; off-platform they 404 and
  // log console errors, so only mount them on an actual Vercel deployment.
  if (!process.env.NEXT_PUBLIC_VERCEL_ENV) {
    return null;
  }

  return <SpeedInsights />;
}